import { ACTIVITY_WS_URL } from '../config';

class ActivityService {
  constructor() {
    this.ws = null;
    this.token = null;
    this.heartbeatInterval = null;
    this.reconnectTimeout = null;
    this.isConnected = false;
    this.connectionAttempts = 0;
  }

  connect(token) {
    if (!token || this.isConnected) return;
    
    this.token = token;
    this.connectionAttempts++;
    const wsUrl = `${ACTIVITY_WS_URL}?token=${token}`;
  

    
    try {
      this.ws = new WebSocket(wsUrl);
      
      this.ws.onopen = () => {
        this.isConnected = true;
        this.connectionAttempts = 0;
        this.startHeartbeat();
      };
      
      this.ws.onclose = (event) => {
        this.isConnected = false;
        this.stopHeartbeat();
        if (event.code !== 1000) { // Only reconnect if not a normal closure
          this.scheduleReconnect();
        }
      };
      
      this.ws.onerror = (error) => {
        this.isConnected = false;
        console.error('[ActivityService] ❌ WebSocket error:', error);
      };
    } catch (error) {
      console.warn('[ActivityService] ❌ Failed to create WebSocket:', error);
    }
  }

  disconnect() {
    this.isConnected = false;
    this.connectionAttempts = 0;
    this.stopHeartbeat();
    if (this.reconnectTimeout) {
      clearTimeout(this.reconnectTimeout);
    }
    if (this.ws) {
      this.ws.close();
      this.ws = null;
    }
  }

  getStatus() {
    return {
      isConnected: this.isConnected,
      connectionAttempts: this.connectionAttempts,
      wsState: this.ws?.readyState,
      hasToken: !!this.token
    };
  }

  startHeartbeat() {
    this.heartbeatInterval = setInterval(() => {
      if (this.ws?.readyState === WebSocket.OPEN) {
        this.ws.send('ping');
      }
    }, 30000);
  }

  stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
    }
  }

  scheduleReconnect() {
    if (this.token && !this.reconnectTimeout && this.connectionAttempts < 5) {
      this.reconnectTimeout = setTimeout(() => {
        this.reconnectTimeout = null;
        this.connect(this.token);
      }, 5000);
    } else if (this.connectionAttempts >= 5) {
      console.log('[ActivityService] ⚠️ Max reconnection attempts reached');
    }
  }
}

export default new ActivityService();